import { ApiModule, type PaginatedResponseData } from '@common/index';
import type { EducationLocationItem, EducationLocation } from '../models';

export class EducationLocationApi extends ApiModule {
  protected endpoint = '/education-location';

  public async pageEducationLocations(params: any) {
    return this.api.post<PaginatedResponseData<EducationLocationItem>, any>(
      `${this.endpoint}/page?page=${params.page}&size=${params.itemsPerPage}&sort=${params.sort ?? ''}`,
      {
        ...params
      }
    );
  }

  public loadEducationLocationDetails(id: number) {
    return this.api.get<EducationLocation>(`${this.endpoint}?id=${id}`);
  }

  public saveEducationLocation(params: any) {
    return this.api.post(`${this.endpoint}`, {
      ...params
    });
  }

  public deleteEducationLocation(id: number) {
    return this.api.delete(`${this.endpoint}?id=${id}`);
  }

  public addNoTutorToEducationLocation(educationLocationId: number) {
    return this.api.post(`${this.endpoint}/add-no-tutor?educationLocationId=${educationLocationId}`);
  }
}
